import { StageDefinition } from './StageDefinition';

export const stage04: StageDefinition = {
    platforms: [
        [23.225806451612904, 0],
        [34.83870967741936, 0],
        [46.45161290322581, 0],
        [69.6774193548387, 0],
        [92.9032258064516, 0],
        [104.51612903225805, 0],
        [116.1290322580645, 0],
        [197.41935483870972, 0],
        [232.2580645161291, 0],
        [290.3225806451614, 0],
        [301.93548387096786, 0],
        [313.5483870967743, 0],
    ],
    traps: [
        [139.3548387096774, 0],
        [150.96774193548387, 0],
        [162.58064516129033, 0],
        [209.03225806451618, 0],
        [220.64516129032265, 0],
        [267.09677419354847, 0],
        [66.3157894736842, 1],
        [75.78947368421052, 1],
    ],
    stars: [
        [36, 1],
        [73, 4],
        [107, 1],
        [192, 1],
        [239, 1],
        [301, 2],
    ],
};
